<template>
    <layout> 

        <template v-slot:label1>Email Address</template>

        <template v-slot:username>
            <v-text-field
                v-model="formData.name"
                dense
                dark
                placeholder="staff@fac.edu.tt"
                outlined
                name="id"                                                
                type="text"
                color="primary"
                clearable
                autofocus
                v-on:keyup="keyPress"
                auto-complete="off"
                class="portal-login__input"
                hide-details
            >
                <v-icon
                    slot="prepend-inner"
                    color="primary"
                >
                    mdi-account
                </v-icon>
            </v-text-field>
        </template>

        <template v-slot:label2>Password</template>

        <template v-slot:password>
            <v-text-field
                v-model="formData.password"
                dense
                dark
                placeholder="Enter password"
                outlined
                v-show="password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"                                                    
                name="password"
                clearable
                autofocus
                color="primary"
                class="portal-login__input"
                hide-details
            >
                <v-icon
                    slot="prepend-inner"
                    color="primary"
                >
                    mdi-key
                </v-icon>
            </v-text-field>
        
            <div class="text-right mt-8">
                <v-btn 
                    color="primary"
                    @click="submit" 
                    dark
                    block
                    rounded
                >
                    LOGIN
                </v-btn>
            </div>
        </template>

    </layout>
</template>

<script>
import Layout from '../layouts/Login';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import axios from 'axios';

export default {
    name: 'LoginTermReports',
    components: {
        Layout
    },
    data: () => ({
        formData: {
            name: '',
            password: '',            
        },
        show: false,        
        password: true,
    }),

    computed: {
        ...mapGetters({            
            authenticated: 'auth/getAuthenticated',
            resetPassword: 'auth/getResetPassword',                       
        }),        
       
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn', 
            employee: 'auth/employee',
            getUser: 'auth/user',
            getUserPermissionList: 'app/getUserPermissionList',
            setAuthenticated: 'auth/setAuthenticated',
            userPermissions: 'auth/userPermissions',
            serverError: 'auth/serverError',          
        }),

        ...mapMutations({
            loginError: 'auth/setLoginErrors', 
            setOverlay: 'auth/setOverlay',
            setUserName: 'auth/setUserName',
            setResetPassword: 'auth/setResetPassword',
            setPermissions: 'auth/setPermissions',
            setEmployeeId: 'auth/setEmployeeId',
            setCredentials: 'auth/setCredentials',
            setAuthenticated: 'auth/setAuthenticated',
            setEmployeeSignedIn: 'auth/setEmployeeSignedIn',
            setEmployeeInitials: 'auth/setEmployeeInitials',
            setUser: 'auth/setUser',
            setAuthToken: 'auth/setAuthToken',   

        }),

        async submit () {
            console.log('Authenticating...');
            this.setOverlay(true);
            this.setCredentials(this.formData); 
            this.setUserName(this.formData.name);
            try {
                const { data } = await this.signIn();
                console.log('data: ', data);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.auth_token;
                this.setAuthToken(data.auth_token);
                sessionStorage.setItem('auth_token', data.auth_token);
                sessionStorage.authenticated = data.name;
                sessionStorage.employeeId = data.employee_id ? data.employee_id : data.name;
                
                const user =  {
                    employee_id: data.employee_id ? data.employee_id : data.name
                }
                this.setUser(JSON.stringify(user));
                sessionStorage.setItem('user', JSON.stringify(user));
                console.log('Authenticated.')                
                this.setAuthenticated(true);
                this.loginError('');                
                
                if(data.name !== 'Admin'){
                    sessionStorage.setItem('employeeSignedIn', data.first_name + ' ' + data.last_name);
                    sessionStorage.setItem('employeeInitials', data.first_name[0] + data.last_name[0])                
                    
                    this.setEmployeeId(data.employee_id);
                    this.setEmployeeSignedIn(data.first_name + ' ' + data.last_name);
                    this.setEmployeeInitials(data.first_name[0] + data.last_name[0]);

                    const { data: dataPermissions } = await this.userPermissions();
                    sessionStorage.setItem('permissions', JSON.stringify(dataPermissions));
                    
                    if(this.resetPassword == 1){
                        this.setOverlay(false);  
                        return;                 
                    }
                } else {
                    sessionStorage.setItem('employeeSignedIn', 'Admin');
                    sessionStorage.setItem('employeeInitials', 'A');

                    this.setEmployeeSignedIn('Admin');
                    this.setEmployeeInitials('A');
                }

                this.$router.replace('/app');

            } catch (error) {
                if(error.response) {
                    console.log(error.response)
                    this.loginError(error.response.data.message);
                }
                else console.log(error);
                this.serverError(error);
                
            } finally {
                this.setOverlay(false);
            }
        },
        
        keyPress (e) {
            if(e.keyCode === 13){
                //
            }
        },
        
    },
}
</script>

<style scoped>
    .v-input.portal-login__input{
    border: 1px solid rgba(245, 241, 230, 0.18);
    background: rgba(245, 241, 230, 0.06);
    border: 1px solid rgba(245, 241, 230, 0.18);
    border-radius: 10px;
    font-size: 14.5px;
    }

    .portal-login__error {
    margin: 0;
    font-size: 12.5px;
    color: #e2a0a0;
    }
</style>